export default __webpack_public_path__ + "static/media/guideToInstantCardhelp.0709ee09.png";